import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

const ICO = 'assets/img/iconos-soporte/';

@Component({
  selector: 'app-soporte',
  templateUrl: './soporte.component.html',
  styleUrls: ['./soporte.component.scss'],
})
export class SoporteComponent implements OnInit, AfterViewInit, OnDestroy {
  typed = '';
  private typeTimer?: ReturnType<typeof setTimeout>;
  private langSub?: Subscription;

  readonly cardIndexes = [0, 1, 2, 3];
  readonly gstItems = [0, 1, 2];
  readonly illus = ICO + 'iconos_soporte-05.svg';

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => this.startTypewriter());
  }

  ngAfterViewInit(): void {
    this.translate.get('soporte.title').subscribe(() => this.startTypewriter());
  }

  get cards() {
    // "/en" en URL del centro de ayuda para el contenido en inglés
    const prefix = this.translate.currentLang === 'en' ? '/en' : '';
    return [
      { icon: ICO + 'iconos_soporte-04.webp', url: `${environment.helpCenterUrl}${prefix}/help/packcert-video-tutoriales` },
      { icon: ICO + 'iconos_soporte-01.webp', url: `${environment.helpCenterUrl}${prefix}/help` },
      { icon: ICO + 'iconos_soporte-02.webp', url: `${environment.helpCenterUrl}${prefix}/help/packcert-preguntas-frecuentes` },
      { icon: ICO + 'iconos_soporte-03.webp', url: `${environment.helpCenterUrl}${prefix}/help/packcert-problemas-soluciones` },
    ];
  }

  private startTypewriter(): void {
    if (this.typeTimer) clearTimeout(this.typeTimer);
    const full = this.translate.instant('soporte.title') as string;
    this.typed = '';
    let i = 0;
    const step = () => {
      if (i < full.length) {
        this.typed += full.charAt(i++);
        this.typeTimer = setTimeout(step, 60);
      }
    };
    step();
  }

  ngOnDestroy(): void {
    if (this.typeTimer) clearTimeout(this.typeTimer);
    this.langSub?.unsubscribe();
  }
}
